/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxFilterOption
 */
export interface FaxFilterOption {
    /**
     * 
     */
    fax_number: string;
    /**
     * Sender source name or recipient facility name
     */
    name?: string;
}

/**
 * Check if a given object implements the FaxFilterOption interface.
 */
export function instanceOfFaxFilterOption(value: object): value is FaxFilterOption {
    if (!('fax_number' in value) || value['fax_number'] === undefined) return false;
    return true;
}

export function FaxFilterOptionFromJSON(json: any): FaxFilterOption {
    return FaxFilterOptionFromJSONTyped(json, false);
}

export function FaxFilterOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxFilterOption {
    if (json == null) {
        return json;
    }
    return {
        
        'fax_number': json['fax_number'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FaxFilterOptionToJSON(json: any): FaxFilterOption {
    return FaxFilterOptionToJSONTyped(json, false);
}

export function FaxFilterOptionToJSONTyped(value?: FaxFilterOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fax_number': value['fax_number'],
        'name': value['name'],
    };
}

